<div class="sh-navigation">
  @if (mainActionItem) {
    <div class="sh-navigation__main-action">
      <sh-action-item [item]="mainActionItem"></sh-action-item>
    </div>
  }
  <ul class="sh-navigation__list">
    @for (item of primaryNavItems; track item) {
      <li class="sh-navigation__list__item">
        <sh-navigation-item [item]="item"></sh-navigation-item>
      </li>
    }
  </ul>
  @if (secondaryNavItems) {
    <ul class="sh-navigation__list -sh-to-bottom">
      @for (item of secondaryNavItems; track item) {
        <li class="sh-navigation__list__item">
          <sh-navigation-item [item]="item" [openDropmenuAbove]="true"></sh-navigation-item>
        </li>
      }
    </ul>
  }
</div>
